module.exports = __webpack_public_path__ + "img/logo.b3f14fb5.png";